import script from "./WikiItemComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WikiItemComponent.vue?vue&type=script&setup=true&lang=js"

import "./WikiItemComponent.vue?vue&type=style&index=0&id=5eea7951&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eea7951"]])

export default __exports__